import React, {Suspense, useRef} from 'react';
import './panel.scss';
import type {PanelProps} from '../../types';
import LoadPanel, {Position} from "devextreme-react/load-panel";

export default function Panel(props: React.PropsWithChildren<PanelProps>) {
    const contentRef = useRef<HTMLDivElement>(null)

    return (
        <div className={'panel dx-card' + (!!props.className ? ' ' + props.className : '')} ref={contentRef}>
            <div className='panel-header'>
                {props.header}
            </div>
            <div className='panel-content'>
                {props.children}
            </div>
            <LoadPanel visible={props.isLoading ?? false} container={contentRef.current ?? undefined}>
                <Position my="center" at="center" of={contentRef.current}/>
            </LoadPanel>
        </div>
    )
}
